import { createSlice } from "@reduxjs/toolkit";

const readCollapsed = () => {
  try {
    return localStorage.getItem("customerSidebarCollapsed") === "1";
  } catch {
    return false;
  }
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState: {
    isOpen: false, // mobile drawer
    collapsed: readCollapsed(), // desktop rail
  },
  reducers: {
    toggleSidebar: (state) => {
      state.isOpen = !state.isOpen;
    },
    closeSidebar: (state) => {
      state.isOpen = false;
    },
    openSidebar: (state) => {
      state.isOpen = true;
    },
    toggleSidebarCollapsed: (state) => {
      state.collapsed = !state.collapsed;
      try {
        localStorage.setItem(
          "customerSidebarCollapsed",
          state.collapsed ? "1" : "0"
        );
      } catch {
        /* ignore */
      }
    },
    setSidebarCollapsed: (state, action) => {
      state.collapsed = Boolean(action.payload);
      try {
        localStorage.setItem(
          "customerSidebarCollapsed",
          state.collapsed ? "1" : "0"
        );
      } catch {
        /* ignore */
      }
    },
  },
});

export const {
  toggleSidebar,
  closeSidebar,
  openSidebar,
  toggleSidebarCollapsed,
  setSidebarCollapsed,
} = sidebarSlice.actions;
export default sidebarSlice.reducer;
